import React, { useState } from 'react';
import './MessageSearch.css';

const MessageSearch = ({ onClose, currentRoomId }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    roomId: currentRoomId || '',
    dateFrom: '',
    dateTo: ''
  });

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;

    setLoading(true);
    try {
      const params = new URLSearchParams({
        query,
        ...Object.fromEntries(Object.entries(filters).filter(([_, v]) => v))
      });

      const response = await fetch(`/api/chat/rooms/messages/search?${params}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const data = await response.json();
      if (data.success) {
        setResults(data.data.messages);
      }
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="search-modal-overlay" onClick={onClose}>
      <div className="search-modal" onClick={(e) => e.stopPropagation()}>
        <div className="search-header">
          <h3>🔍 Search Messages</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSearch} className="search-form">
          <input
            type="text"
            placeholder="Search for messages..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="search-input"
            autoFocus
          />

          <div className="search-filters">
            <label>
              Date From:
              <input
                type="date"
                value={filters.dateFrom}
                onChange={(e) => setFilters({...filters, dateFrom: e.target.value})}
              />
            </label>
            <label>
              Date To:
              <input
                type="date"
                value={filters.dateTo}
                onChange={(e) => setFilters({...filters, dateTo: e.target.value})}
              />
            </label>
          </div>

          <button type="submit" className="search-btn" disabled={loading || !query.trim()}>
            {loading ? 'Searching...' : 'Search'}
          </button>
        </form>

        <div className="search-results">
          {results.length > 0 ? (
            results.map(msg => (
              <div key={msg._id} className="search-result-item">
                <div className="result-header">
                  <span className="result-author">{msg.senderId.username}</span>
                  <span className="result-room">#{msg.roomId.name}</span>
                  <span className="result-time">{new Date(msg.createdAt).toLocaleString()}</span>
                </div>
                <div className="result-content">{msg.content}</div>
              </div>
            ))
          ) : query && !loading ? (
            <div className="no-results">No messages found</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MessageSearch;
